import React, { useEffect, useState } from "react";
import "./WinnersHome.css";
import rectangle from "../../Images/Rectangle 6667501.png";
import bars from "../../Images/Group 1171279334.png";
import WinnersHomeCities from "./WinnersHomeCities";
import WinnersPropertyDealers from "./WinnersPropertyDealers";
import WinnersAbout from "./WinnersAbout";
import PreferedCity from "./PreferedCity";
import Apartments from "./Apartments";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Header from "../../Layout/Header";
import Header2 from "../../Layout/Header2";
import city from "../../Images/Mask group.png";
import play from "../../Images/Group (1).png";
import WinnersTestimonial from "./WinnersTestimonial";
import WinnersClient from "./WinnersClient";
import Sidebar2 from "../../Layout/Sidebar2";
import HomeService from "../../Services/HomeService";
import WhatsAppButton from "../../Component/WhatsAppButton";
import CallUsButton from "../../Component/CallUsButton";
const WinnersHome = () => {
  const [token, setToken] = useState(null);
  const [banner, setBanner] = useState([]);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getAllBanner = async () => {
    const res = await HomeService.getBanner();
    if (res?.status) {
      setBanner(res.data);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    setToken(token);
    getAllBanner();
  }, []);

  return (
    <>
    <WhatsAppButton phoneNumber="919834737373" textMessge="Hello"/>
    <CallUsButton />
      <div className="uni_wrapper">
        <div className="uni_container">
          <div className="winner_home_content_wrapper ">
            <Header2 />
            <div className="gateway_to_dream_wrapper">
              <Slider {...settings}>
                {banner.map((e) => {
                  return (
                    <>
                      <div className="gateway_to_dream_div">
                        <div className="gateway_to_dream_content_div">
                          <h1>
                            <span>{e.title}</span>
                          </h1>
                          <p className="discover_para_5">{e.description}</p>
                          <div className="gateway_dream_div">
                            <button className="discover_btn_5">
                              Discover Now
                            </button>
                            <button className="watch_demo_btn_5">
                              <img src={play} />
                              Watch Demo
                            </button>
                          </div>
                        </div>
                        <div className="gateway_to_dream_img_div">
                          <div className="gateway_to_dream_img">
                          <img 
                            style={{borderRadius:'50px 0px 0px 50px'}}
                             src={e.image} />
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </Slider>
            </div>
            {/* <Slider {...settings}>
              <div>
              <div className='real_estate_div'>
                <div className='real_estate_content'>
                    <div className='bars_img'>
                        <img src={bars}></img>
                    </div>

                    <div style={{padding:'0px 40px'}}>
                        <h1 className='real-head'>REAL</h1>
                        <h1 className='estate-head'>ESTATE</h1>
                        <p className='estate-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
                        <div className='real-estate-icons-div-wrapper'>
                    <div className='social-icons-img-div'>
                    <i className="fa-brands fa-instagram "></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-facebook-f"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-twitter"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-whatsapp"></i>
                    </div>
                </div>

                <div className='real-estate-contact-icons-div'>
                    <div className='real-estate-contact-wrapper'>
                        <i class="fa-solid fa-phone"></i>
                        <p>00 54 8 352 587994</p>
                    </div>

                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-globe"></i>
                        <p>www.yourweb.com</p>
                    </div>
                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-envelope"></i>
                        <p>yourcompany@gmail.com</p>
                    </div>
                </div>
                    </div>

                </div>
                <div className='real_estate_img_div'>
                    <img src={rectangle}></img>
                </div>

                
            </div>
              </div>

              <div>
              <div className='real_estate_div'>
                <div className='real_estate_content'>
                    <div className='bars_img'>
                        <img src={bars}></img>
                    </div>

                    <div style={{padding:'0px 40px'}}>
                        <h1 className='real-head'>REAL</h1>
                        <h1 className='estate-head'>ESTATE</h1>
                        <p className='estate-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
                        <div className='real-estate-icons-div-wrapper'>
                    <div className='social-icons-img-div'>
                    <i className="fa-brands fa-instagram "></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-facebook-f"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-twitter"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-whatsapp"></i>
                    </div>
                </div>

                <div className='real-estate-contact-icons-div'>
                    <div className='real-estate-contact-wrapper'>
                        <i class="fa-solid fa-phone"></i>
                        <p>00 54 8 352 587994</p>
                    </div>

                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-globe"></i>
                        <p>www.yourweb.com</p>
                    </div>
                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-envelope"></i>
                        <p>yourcompany@gmail.com</p>
                    </div>
                </div>
                    </div>

                </div>
                <div className='real_estate_img_div'>
                    <img src={rectangle}></img>
                </div>

                
            </div>
              </div>

              <div>
              <div className='real_estate_div'>
                <div className='real_estate_content'>
                    <div className='bars_img'>
                        <img src={bars}></img>
                    </div>

                    <div style={{padding:'0px 40px'}}>
                        <h1 className='real-head'>REAL</h1>
                        <h1 className='estate-head'>ESTATE</h1>
                        <p className='estate-para'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut</p>
                        <div className='real-estate-icons-div-wrapper'>
                    <div className='social-icons-img-div'>
                    <i className="fa-brands fa-instagram "></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-facebook-f"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-twitter"></i>
                    </div>
                    <div className='social-icons-img-div'>
                    <i class="fa-brands fa-whatsapp"></i>
                    </div>
                </div>

                <div className='real-estate-contact-icons-div'>
                    <div className='real-estate-contact-wrapper'>
                        <i class="fa-solid fa-phone"></i>
                        <p>00 54 8 352 587994</p>
                    </div>

                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-globe"></i>
                        <p>www.yourweb.com</p>
                    </div>
                    <div className='real-estate-contact-wrapper'>
                    <i class="fa-solid fa-envelope"></i>
                        <p>yourcompany@gmail.com</p>
                    </div>
                </div>
                    </div>

                </div>
                <div className='real_estate_img_div'>
                    <img src={rectangle}></img>
                </div>

                
            </div>
              </div>
        </Slider> */}
          </div>
          <WinnersHomeCities />

          {token ? <WinnersPropertyDealers /> : ""}
          <WinnersAbout />
          <PreferedCity />
          <Apartments />
          <WinnersTestimonial />
          <WinnersClient />
        </div>
      </div>
    </>
  );
};

export default WinnersHome;
